import { render, staticRenderFns } from "./CaretUpIcon.vue?vue&type=template&id=58bd0e92"
import script from "./CaretUpIcon.vue?vue&type=script&lang=js"
export * from "./CaretUpIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports